import React, { useEffect } from "react";
import { LiveHelp as LiveHelpIcon } from "@material-ui/icons";
import { Fab } from "@material-ui/core";
import config from "config";
import { Club } from "api/clubs";
import { BeaconCommand } from "utils/helpers";
import "./helpscoutFabStyle.scss";

interface HelpscoutFebProps {
    club?: Club | null;
}

// helpscout beacon action button
const HelpscoutFab = ({ club }: HelpscoutFebProps) => {
    const isCompany = club?.capabilities.includes("company");
    useEffect(() => {
        window.Beacon(BeaconCommand.DESTROY);
        if (isCompany) {
            window.Beacon(BeaconCommand.INIT, config.helpscout.B2BbeaconId);
        } else {
            window.Beacon(BeaconCommand.INIT, config.helpscout.beaconId);
        }
        window.Beacon(BeaconCommand.CONFIG, { display: { zIndex: 1260, hideFABOnMobile: true } });
    }, [club]);

    return (
        <>
            <Fab
                color="primary"
                size="medium"
                className="helpIcon"
                onClick={() => window.Beacon("toggle")}
            >
                <LiveHelpIcon />
            </Fab>
        </>
    );
};

export default HelpscoutFab;
